<template>
  <div class="container" style="background-color: #fdfdfe">
    <div class="top_title">
      <!-- 返回按钮 -->
      <router-link class="icon_back" :to="{ name: 'H800020' }" tag="span"></router-link>
      <span style="padding-right: 2.4rem">生成电子合同</span>
    </div>
    <div class="scroll_area" :style="'overflow-y: auto;height: '+height+'px;'">
      <div style="margin-top: 2.4rem;margin-left: .5rem;margin-right: .5rem;">

        <pdf :src="PDAPath"></pdf>
        <pdf :src="PDAPath" :page="2"></pdf>

        <div style="font-size: .8rem;margin-bottom: 1rem;">签名区 <span
          style="color: rgb(229, 28, 28);">（签名和家长姓名及退费户名确保一致）</span>
        </div>
        <vue-esign ref="esign" style="border: 1px solid #000;margin: 0 auto;" :width="width" :height="120"
                   :isCrop="isCrop"
                   :lineWidth="lineWidth" :lineColor="lineColor" :isClearBgColor="isClearBgColor"
                   :bgColor.sync="bgColor"/>
        <div style="display: flex;flex-direction: row-reverse;margin-top: .5rem">
          <div style="margin-left: 1rem;">
            <button class="btn" @click="handleGenerate">上传签名</button>
          </div>
          <div>
            <button class="btn" @click="handleReset">清空签名区</button>
          </div>
        </div>
        <div style="margin-top:0.5rem">
          <label>
            <input type="checkbox" @click="onClickCheck">已阅读且同意合同内容</label>
        </div>
        <button style="margin-top:0.5rem" class="bottom_btn" @click="onClickSearch">生成电子合同</button>

        <div style="height: 3rem;"></div>
      </div>

    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import vueEsign from 'vue-esign'
import weui from "weui.js";
import dataRequestFactory from "../factories/dataRequestFactory";
import axios from "../common/axios";
import {ajaxUrl} from '@/common/config'

export default {
  data() {
    return {
      lineWidth: 2,
      lineColor: '#000000',
      bgColor: '#FFF',
      resultImg: '',
      isCrop: false,
      isClearBgColor: false,
      width: '',
      height: '',
      I_CHECKED_FLAG: false,
      PDAPath: '',
      I_SCHOOL_VALUE: '',
      I_TEL: '',
      I_STUDENT_NAME: '',
    }
  },
  components: {
    pdf,
    vueEsign
  },
  created() {
    this.width = $(window).width() - 20;
    this.height = $(window).height();

    window.document.title = '易文乐未消耗课时退费'
  },
  mounted() {
    var win_h = $(window).height();  //关键代码
    $("body").height(win_h);  //关键代码

    let params = this.$route.params

    if (params.I_SCHOOL_NO) {
      this.I_SCHOOL_VALUE = params.I_SCHOOL_NO
    } else {
      this.I_SCHOOL_VALUE = window.localStorage.getItem("I_SCHOOL_NO") || ''
    }

    if (params.I_PHONE) {
      this.I_TEL = params.I_PHONE
    } else {
      this.I_TEL = window.localStorage.getItem("I_PHONE") || ''
    }

    if (params.I_STUDENT_NAME) {
      this.I_STUDENT_NAME = params.I_STUDENT_NAME
    } else {
      this.I_STUDENT_NAME = window.localStorage.getItem("I_STUDENT_NAME") || ''
    }

    if (params.PDAPath) {
      this.PDAPath = params.PDAPath
    }

  },
  methods: {
    onClickSearch() {
      let that = this
      if (this.resultImg === '') {
        weui.topTips('请先上传签名');
        return
      }
      if (!this.I_CHECKED_FLAG) {
        weui.topTips('未同意合同内容');
        return
      }

      weui.confirm('同意协议退费金额，生成电子合同不可更改，确定？', function () {
        console.log('yes')
        let requestParams = {
          "I_SCHOOL_NO": that.I_SCHOOL_VALUE,
          "I_PHONE": that.I_TEL,
          "I_STUDENT_NAME": that.I_STUDENT_NAME,
        }
        dataRequestFactory.I800031(requestParams).then(res => {
          if (res.resultCode === '0') {
            that.PDAPath = 'http://' + res.PDAPath
            that.$router.push({
              name: 'H800040',
              params: {
                I_SCHOOL_NO: that.I_SCHOOL_VALUE,
                I_PHONE: that.I_TEL,
                I_STUDENT_NAME: that.I_STUDENT_NAME,
                PDAPath: that.PDAPath,
              }
            })
          }
        }).catch(err => {
          if (err.errorDesc === '请选择校区') {
            that.$router.replace({name: 'H800010'})
          }
        })
      }, function () {
        console.log('no')
      });

    },
    handleReset() {
      this.$refs.esign.reset()
      this.resultImg = ''
    },
    handleGenerate() {
      let that = this
      this.$refs.esign.generate().then(res => {
        this.resultImg = res
        try {
          axios.post(ajaxUrl + '/Ashx/I800030.ashx',{
            "I_SCHOOL_NO": that.I_SCHOOL_VALUE,
            "I_PHONE": that.I_TEL,
            "I_STUDENT_NAME": that.I_STUDENT_NAME,
            "I_SING_IMG": that.resultImg,
          }).then(res=>{
            console.log(res)
            if (res.data.resultCode === '0') {
              weui.toast(res.data.errorDesc)
            }
          })
          // dataRequestFactory.I800030(requestParams).then(res => {
          //   if (res.resultCode === '0') {
          //     weui.toast(res.errorDesc)
          //   }
          // }).catch(err => {
          //   if (err.errorDesc === '请选择校区') {
          //     this.$router.replace({name: 'H800010'})
          //   }
          // })

        } catch (e) {
          console.error(e)
        }
      }).catch(err => {
        if (err === 'Warning: Not Signned!') {
          weui.topTips('请先签名再上传');
        }
      })
    },
    onClickCheck() {
      this.I_CHECKED_FLAG = !this.I_CHECKED_FLAG
    }
  }
}
</script>

<style scoped>
.btn {
  height: 2.38rem;
  line-height: 2.28rem;
  color: #1277f8;
  text-align: center;
  font-size: 0.8rem;
  display: block;
  width: 6rem;
  background-color: #FFF;
  border-radius: 6px;
  border: 0.1rem solid #1277f8;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/H800030.vue